/**
 * Created by ivo on 22.05.14.
 *
 * Mixin to add options to a component
 *
 */

define([
    'jQuery',
    'underscore'
    ],
    function($, _) {
        var OptionsMixin = {
            /**
             * Internal variable to store configuration values
             */
            _options: {},

            /**
             * Adds options to the widget.
             * The parameter options will overwrite the defaults
             * @param {object} defaults
             * @param {object|undefined} options
             * @returns {undefined}
             */
            addOptions: function(defaults, options){
                this._options = $.extend({}, this.getOptions(), defaults, options || {});
            },

            /**
             * Returns an object of all configuration options of the widget
             * @returns {undefined|Object}
             */
            getOptions: function(){
                return this._options;
            },

            /**
             * Gets or sets option
             * @param name
             * @param value optional
             */
            option: function (name, value) {
                if (!_.isUndefined(value)) {
                    this._options[name] = value;
                }
                return this._options[name];
            }
        };

        return OptionsMixin;
    }
);


//////////////////
// WEBPACK FOOTER
// ./~/fcse-component/optionsMixin.js
// module id = 9
// module chunks = 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23